import React from 'react';
import { LandingPage } from './src/pages/LandingPage';
export function App() {
  return <LandingPage data-id="element-0" />;
}